import ErrorPage from "application/pages/SearchPageComponents/ResultsBoxComponents/ErrorPage";
import Loading from "application/pages/SearchPageComponents/ResultsBoxComponents/Loading";
import StartSearch from "application/pages/SearchPageComponents/ResultsBoxComponents/StartSearch";
import Results from "application/pages/SearchPageComponents/ResultsBoxComponents/Results";
import styles from "./ResultsBox.module.css";
import NoResultsFound from "./ResultsBoxComponents/NoResultsFound";

const ResultsBox = ({loading,results,error,userId}) => {
    return ( 
        <div id="ResultsBox" className={styles.resultsBox}>
            {/* START SEARCH MESSAGE */}
            {!results && !error && !loading && <StartSearch />}
            {loading && <Loading />}
            {results && results.contacts.length > 0 && !error && !loading && <Results results={results} userId={userId}/>}
            {error && <ErrorPage />}
            {results && results.contacts.length === 0 && !error && !loading && <NoResultsFound />}
        </div>
            
    );
}
 
export default ResultsBox;